// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-JP1":"JP1_dpu-detail-JP1__t8NIA"};